export default {
  BROKER_TYPES: {
    PROTERYX_TERMINAL_US: "PROTERYX_TERMINAL_US",
    TRADOVATE_DIRECT_MULTIPLE: "TRADOVATE_DIRECT_MULTIPLE",
  },
  ALL_BROKER_TYPES: {
    PROTERYX_TERMINAL: "PROTERYX_TERMINAL",
    PROTERYX_TERMINAL_US: "PROTERYX_TERMINAL_US",
    TRADOVATE_DIRECT_MULTIPLE: "TRADOVATE_DIRECT_MULTIPLE",
  },
  BROKER_TYPES_VIEW: {
    PROTERYX_TERMINAL: "Interactive Brokers BO",
    PROTERYX_TERMINAL_US: "Interactive Brokers",
    TRADOVATE_DIRECT: "Tradovate (s)",
    TRADOVATE_DIRECT_MULTIPLE: "Tradovate",
  },
  TRADING_MODES: {
    LIVE: "live",
    PAPER: "paper",
  },
  TRADOVATE_SESSION_MODES: {
    LIVE: "live",
    DEMO: "demo",
  },
  BROKERS: null,
  SYMBOL_DATA_TYPES: {
    TRADOVATE: "TRADOVATE",
    INTERACTIVE_BROKERS: "INTERACTIVE_BROKERS",
  },
  ACTIONS_VIEWSELECT: [
    { name: "Buy", value: "BUY" },
    { name: "Sell", value: "SELL" },
  ],
  TRADOVATE_ACTIONS: {
    BUY: "Buy",
    SELL: "Sell",
  },
  IB_ACTIONS: {
    BUY: "BUY",
    SELL: "SELL",
  },
  AUTO_TRADER_TYPES: {
    STRATEGY: "STRATEGY",
    SIGNAL: "SIGNAL",
  },
  AUTO_TRADER_TYPES_VIEW: {
    STRATEGY: "Strategy",
    SIGNAL: "Indicator",
  },
  ORDER_TYPES: {
    MARKET: "MARKET",
    LIMIT: "LIMIT",
    STOP: "STOP",
  },
  ORDER_TYPES_VIEWSELECT: [
    { name: "Market", value: "MARKET" },
    { name: "Limit", value: "LIMIT" },
    { name: "Stop", value: "STOP" },
  ],
  TRADOVATE_ORDER_TYPES: {
    MARKET: "Market",
    LIMIT: "Limit",
    STOP: "Stop",
  },
  IB_ORDER_TYPES: {
    MARKET: "MKT",
    LIMIT: "LMT",
    STOP: "STP",
  },
  TIF_TYPES_VIEWSELECT: [
    { name: "GTC", value: "GTC" },
    { name: "Day", value: "DAY" },
  ],
  TRADOVATE_TIF_TYPES: {
    GTC: "GTC",
    DAY: "Day",
  },
  IB_TIF_TYPES: {
    GTC: "GTC",
    DAY: "DAY",
  },
  DELTA_TYPES_VIEWSELECT: [{ name: "Delta Price", value: "price" }],
  get_brokers() {
    return [
      {
        type: this.BROKER_TYPES.PROTERYX_TERMINAL_US,
        name: this.BROKER_TYPES_VIEW[this.BROKER_TYPES.PROTERYX_TERMINAL_US],
        img: "https://brokers.education.investing.com/mx/wp-content/uploads/sites/16/2023/03/Interactive-Brokers.png",
        img_local: "Interactive-Brokers.png",
      },
      // {
      //   type: this.BROKER_TYPES.PROTERYX_TERMINAL,
      //   name: this.BROKER_TYPES_VIEW[this.BROKER_TYPES.TRADOVATE_DIRECT],
      //   img: "https://brokers.education.investing.com/mx/wp-content/uploads/sites/16/2023/03/Interactive-Brokers.png",
      // },
      // {
      //   type: this.BROKER_TYPES.TRADOVATE_DIRECT,
      //   name: this.BROKER_TYPES_VIEW[this.BROKER_TYPES.PROTERYX_TERMINAL],
      //   img: "https://www.jigsawtrading.com/wp-content/uploads/2020/02/Traddd.jpg",
      //   short_desc: "Single Account",
      // },
      {
        type: this.BROKER_TYPES.TRADOVATE_DIRECT_MULTIPLE,
        name: this.BROKER_TYPES_VIEW[
          this.BROKER_TYPES.TRADOVATE_DIRECT_MULTIPLE
        ],
        img: "https://www.jigsawtrading.com/wp-content/uploads/2020/02/Traddd.jpg",
        img_local: "Traddd.jpg",
        short_desc: "Multiple Account",
      },
    ];
  },
  get_broker_type_view(type_view) {
    if (this.BROKER_TYPES_VIEW[type_view]) {
      return this.BROKER_TYPES_VIEW[type_view];
    } else return type_view;
  },
  get_broker(broker_type) {
    if (this.BROKERS == null) this.BROKERS = this.get_brokers();
    return this.BROKERS.find((b) => b.type == broker_type);
  },
  get_auto_trader_types() {
    return [this.AUTO_TRADER_TYPES.STRATEGY, this.AUTO_TRADER_TYPES.SIGNAL];
  },
  get_trading_modes() {
    return [this.TRADING_MODES.LIVE, this.TRADING_MODES.PAPER];
  },
  get_session_type_modes() {
    return [
      this.TRADOVATE_SESSION_MODES.LIVE,
      this.TRADOVATE_SESSION_MODES.DEMO,
    ];
  },
  is_tradovate(option) {
    return option == this.BROKER_TYPES.TRADOVATE_DIRECT_MULTIPLE;
  },
  is_interactive_broker(option) {
    return (
      option == this.BROKER_TYPES.PROTERYX_TERMINAL_US ||
      option == this.ALL_BROKER_TYPES.PROTERYX_TERMINAL
    );
  },
  get_symbol_data_type(option) {
    if (this.is_tradovate(option)) {
      return this.SYMBOL_DATA_TYPES.TRADOVATE;
    } else if (this.is_interactive_broker) {
      return this.SYMBOL_DATA_TYPES.INTERACTIVE_BROKERS;
    }
    return option;
  },
};
